import { motion } from "framer-motion";
import { Box, Typography } from "@mui/material";

export const Navigation = ({
  isOpen,
  toggle,
}: {
  isOpen: boolean;
  toggle: any;
}) => (
  <motion.ul
    style={{
      display: isOpen ? "flex" : "none",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      gap: "15px",
      // position: "relative",
    }}
  >
    <Box
      onClick={toggle}
      component={motion.div}
      style={{
        zIndex: 3,
        width: "100%",
      }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        padding: "12px 20px",
      }}
    >
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, x: -16 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.25, duration: 0.4, ease: "easeOut" }}
        >
          <a
            href="https://linktr.ee/louiscappell"
            target="_blank"
            rel="noreferrer"
            style={{
              textDecoration: "none",
              color: "#030303",
            }}
          >
            <Typography
              sx={{
                zIndex: 100,
                fontFamily: "inter",
                fontSize: "clamp(22px, 6vw, 26px)",
                fontWeight: 600,
                whiteSpace: "nowrap",
              }}
            >
              contact me.
            </Typography>
          </a>
        </motion.div>
      )}
    </Box>
    <Box
      component={motion.div}
      onClick={toggle}
      style={{
        zIndex: 3,
        width: "100%",
      }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        padding: "12px 20px",
      }}
    >
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, x: -16 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.32, duration: 0.4, ease: "easeOut" }}
        >
          <a
            href="#work"
            style={{
              textDecoration: "none",
              color: "#030303",
            }}
          >
            <Typography
              sx={{
                zIndex: 100,
                fontFamily: "inter",
                fontSize: "clamp(22px, 6vw, 26px)",
                fontWeight: 600,
                whiteSpace: "nowrap",
              }}
            >
              my work.
            </Typography>
          </a>
        </motion.div>
      )}
    </Box>
  </motion.ul>
);
